import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { CreateScenarioPool } from '../../types/scenario-modeling.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const useCreateScenarioPool = () => {
  const { invalidateQuery: invalidateViewQueries } = useInvalidateQueries(
    QueryKey.GET_SCENARIO_POOLS,
  );

  const { mutate: createPool, isPending } = useAppMutation([QueryKey.CREATE_SCENARIO_POOL], {
    mutationFn: ({ scenarioId, data }: { data: CreateScenarioPool; scenarioId: string }) =>
      ApiService.post(
        { endpoint: BackendRoute.SCENARIOS, routePath: [scenarioId, 'pools'] },
        { body: data },
      ),
    onSuccess: () => {
      invalidateViewQueries();
    },
  });
  return { createPool, isPending };
};
